// Ported from Kratos UncaughtExceptionListener: https://github.zappos.amazon.dev/mweb/kratos/pull/2640

export interface UncaughtExceptionPayload {
  message: string;
  filename: string;
  lineno: number;
  colno: number;
  page_type: string;
  source: 'error' | 'unhandledrejection';
}

export function isFirstPartyError(filename: string | undefined, siteDomain: string): boolean {
  if (!filename) {
    return false;
  }
  return filename.includes(siteDomain);
}

export function isScriptError(message: string, filename: string | undefined): boolean {
  return message === 'Script error.' && (!filename || filename === '');
}

export function shouldEmitError(message: string, filename: string | undefined, siteDomain: string): boolean {
  return !isScriptError(message, filename) && isFirstPartyError(filename, siteDomain);
}

export function truncateMessage(message: string | undefined | null, maxLength: number): string {
  if (message === null || message === undefined) {
    return '';
  }
  const str = String(message);
  return str.length > maxLength ? str.slice(0, maxLength) : str;
}

export function buildDeduplicationKey(message: string, filename: string, lineno: number, colno: number): string {
  return `${message}|${filename}|${lineno}|${colno}`;
}

export function buildUncaughtExceptionPayload(
  message: string,
  filename: string,
  lineno: number,
  colno: number,
  pageType: string,
  source: 'error' | 'unhandledrejection'
): UncaughtExceptionPayload {
  return { message, filename, lineno, colno, page_type: pageType, source };
}
